/**
 * Normalize description for comparison - ignore formatting-only changes
 * Strips extra whitespace, normalizes line breaks, trims
 */
export function normalizeForComparison(
  text: string | null | undefined,
): string {
  if (!text) return ''
  return text
    .replace(/\r\n/g, '\n')
    .replace(/[ \t]+/g, ' ')
    .replace(/\n\s*\n/g, '\n\n')
    .trim()
}

export function descriptionContentChanged(
  current: string | null | undefined,
  previous: string | null | undefined,
): boolean {
  return normalizeForComparison(current) !== normalizeForComparison(previous)
}

/**
 * Normalize date string to YYYY-MM-DD format for comparison
 * Uses local timezone to avoid date shifts from UTC conversion
 */
function normalizeDateForComparison(
  dateStr: string | null | undefined,
): string {
  if (!dateStr) return ''
  const date = new Date(dateStr)
  if (isNaN(date.getTime())) return dateStr // Invalid date, return as-is
  // Use local date components to avoid timezone shifts
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

/**
 * Compare two date strings, ignoring time component differences
 * Returns true if the dates represent different calendar days
 */
export function dateChanged(
  current: string | null | undefined,
  previous: string | null | undefined,
): boolean {
  return (
    normalizeDateForComparison(current) !== normalizeDateForComparison(previous)
  )
}
